module.exports = __webpack_public_path__ + "static/img/gaozhonglishi4.79fe2e07.jpg";